module.exports = {"title":"Download your tickets","content":"Click on the button to download your tickets.","download":"Download","msg":{"yay":"Yay!","oops":"Oops!","error":"Your token is invalid."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Unsubscribe/locales/fr.json
// module id = 1998
// module chunks = 0